import { Injectable } from '@angular/core';
import { sanitizeTelemetryUrl } from './beacon-telemetry.service';
import { HttpTelemetryEvent, TelemetryService } from './telemetry.service';

@Injectable()
export class ConsoleTelemetryService extends TelemetryService {
  trackHttpRequest(event: HttpTelemetryEvent): void {
    const payload = {
      method: event.method,
      url: sanitizeTelemetryUrl(event.url),
      status: event.status,
      durationMs: Math.round(event.durationMs),
      succeeded: event.succeeded,
      errorKind: event.errorKind,
    };

    console.info('[telemetry.http]', payload);
  }
}
